import AscPowerBiContainer from './containers/AscPowerBiContainer.vue'

const powerBiRouter = {
  icon: 'mdi-collage',
  path: '/dashboards',
  name: 'dashboards',
  display: true,
  component: AscPowerBiContainer,
  meta: {
    primaryNavigation: true,
    requiresEccn: true,
    tooltip: 'View Dashboards',
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'Dashboards',
      },
    ],
  },
  children: [],
}

export default powerBiRouter
